const formatter = new Intl.DateTimeFormat('ru-RU');
export default (date) => formatter.format(new Date(date));
